import React, { useState, createContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { CompanySetup } from './pages/CompanySetup';
import { AdminDashboard } from './pages/AdminDashboard';
import { EmployeeDashboard } from './pages/EmployeeDashboard';
import { ExpenseEntry } from './pages/ExpenseEntry';
import { Employees } from './pages/Employees';
import { Settings } from './pages/Settings';
import { KnowledgeBase } from './pages/KnowledgeBase';
import './styles/tooltip.css';
import { ExpenseAIAssistant } from './components/ai/ExpenseAIAssistant';
// Simple auth context for the POC
export const AuthContext = createContext({
  isAuthenticated: false,
  userRole: null,
  login: role => {},
  logout: () => {},
  userInfo: {
    id: 1,
    name: 'John Doe',
    email: 'john.doe@example.com'
  }
});
export function App() {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    userRole: null,
    userInfo: {
      id: 1,
      name: 'John Doe',
      email: 'john.doe@example.com'
    }
  });
  const login = role => {
    setAuthState({
      isAuthenticated: true,
      userRole: role,
      userInfo: {
        id: 1,
        name: 'John Doe',
        email: 'john.doe@example.com'
      }
    });
  };
  const logout = () => {
    setAuthState({
      isAuthenticated: false,
      userRole: null,
      userInfo: {
        id: 1,
        name: 'John Doe',
        email: 'john.doe@example.com'
      }
    });
  };
  return <AuthContext.Provider value={{
    ...authState,
    login,
    logout
  }} data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen bg-gray-900 text-gray-100" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
            {/* Protected routes */}
            <Route element={<Layout data-id="element-7" />} data-id="element-6">
              <Route path="/setup" element={authState.isAuthenticated ? <CompanySetup data-id="element-9" /> : <Navigate to="/login" data-id="element-10" />} data-id="element-8" />
              <Route path="/admin" element={authState.isAuthenticated && authState.userRole === 'admin' ? <AdminDashboard data-id="element-12" /> : <Navigate to="/login" data-id="element-13" />} data-id="element-11" />
              <Route path="/dashboard" element={authState.isAuthenticated ? <EmployeeDashboard data-id="element-15" /> : <Navigate to="/login" data-id="element-16" />} data-id="element-14" />
              <Route path="/expense/new" element={authState.isAuthenticated ? <ExpenseEntry data-id="element-18" /> : <Navigate to="/login" data-id="element-19" />} data-id="element-17" />
              <Route path="/employees" element={authState.isAuthenticated && authState.userRole === 'admin' ? <Employees data-id="element-21" /> : <Navigate to="/login" data-id="element-22" />} data-id="element-20" />
              <Route path="/settings" element={authState.isAuthenticated ? <Settings data-id="element-24" /> : <Navigate to="/login" data-id="element-25" />} data-id="element-23" />
              <Route path="/knowledge-base" element={authState.isAuthenticated ? <KnowledgeBase data-id="element-27" /> : <Navigate to="/login" data-id="element-28" />} data-id="element-26" />
            </Route>
            {/* Redirect root to appropriate dashboard or login */}
            <Route path="/" element={!authState.isAuthenticated ? <Navigate to="/login" data-id="element-30" /> : authState.userRole === 'admin' ? <Navigate to="/admin" data-id="element-31" /> : <Navigate to="/dashboard" data-id="element-32" />} data-id="element-29" />
          </Routes>
          {/* AI Assistant - shown on all pages when authenticated */}
          {authState.isAuthenticated && <ExpenseAIAssistant data-id="element-33" />}
        </div>
      </BrowserRouter>
    </AuthContext.Provider>;
}